import { AuthRouteTargets } from 'src/app/auth/@shared/auth-route-targets.types';

export const AUTH_ROUTE_TARGETS: AuthRouteTargets = {
  loginRedirect: '/home',
  // Public app has no auth flow; password reset deep links must fallback to home.
  passwordResetRedirect: (): string => {
    return '/home';
  },
};
